import React from 'react'

export const Footer = () => {
    return (
        <footer>
            <p>Made by Sofie Pellegrini, Lisa Bergström, Jessica Sandler, Emma Berg and Terese Claesson </p>
            <p>Technigo Bootcamp Spring 2022 </p>
        </footer>
    )
}